<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Practice Test">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>
        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Number Of Attempts
          <input
            class="form-control"
            type="number"
            v-model="attempts"
            @focus="attemptsEmpty = false"
          />
          <div v-if="attemptsEmpty" style="color: red">
            Number of attempts is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Negative Marks
          <input
            class="form-control"
            type="number"
            v-model="negativeMarks"
            @focus="negativeMarkEmpty = false"
          />
          <div v-if="negativeMarkEmpty" style="color: red">
            Negative mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Each Question Mark
          <input
            class="form-control"
            type="number"
            v-model="eachQuestionMark"
            @focus="eachQuestionMarkEmpty = false"
          />
          <div v-if="eachQuestionMarkEmpty" style="color: red">
            Each question mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Result Status
          <b-form-select
            v-model="resultStatus"
            @change="resultStatusEmpty = false"
          >
            <option
              v-for="(resultStatusOption, index) in resultStatusOptions"
              :key="index"
              :value="resultStatusOption.value"
            >
              {{ resultStatusOption.text }}
            </option>
          </b-form-select>
          <div v-if="resultStatusEmpty" style="color: red">
            Result status is required
          </div>
        </div>

        <div class="form-group col-md-6">
          Duration (mins)
          <input
            class="form-control"
            type="number"
            v-model="duration"
            @focus="durationEmpty = false"
          />
          <div v-if="durationEmpty" style="color: red">
            Duration is required
          </div>
        </div>

        <div class="col-md-6 form-group d-flex justify-content-between">
          <b-form-checkbox
            id="checkbox-1"
            v-model="has_coding"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            Has Coding
          </b-form-checkbox>
          <b-form-checkbox
            id="checkbox-2"
            v-model="play_button"
            name="checkbox-2"
            value="1"
            unchecked-value="0"
            class="mx-5"
          >
            Play & Pause
          </b-form-checkbox>
        </div>

        <div class="col-md-6 form-group">
          Test Type
          <b-form-select
            v-model="testType"
            @change="testTypeEmpty = false"
            :disabled="finalArray.length > 0 || finalArray2.length > 0"
          >
            <option value="random">Random</option>
            <option value="default">Default</option>
          </b-form-select>
          <div v-if="testTypeEmpty" style="color: red">
            Test type is required
          </div>
        </div>

        <!-- modal 1 -->

        <b-modal
          id="modal-1"
          title="Add Questions"
          size="xl"
          ref="modalone"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="
            (questionData = []),
              (parentTopic = ''),
              (topic = ''),
              (subtopic = ''),
              (freeStatus = ''),
              (freeStatusEmpty = false),
              (parentTopicEmpty = false),
              (topicEmpty = false),
              (subtopicEmpty = false)
          "
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Parent Topic
              <b-form-select
                v-model="parentTopic"
                @change="getTopics()"
                required
              >
                <option
                  v-for="(parentTopic, index) in parentTopics"
                  :key="index"
                  :value="parentTopic.id"
                >
                  {{ parentTopic.name }}
                </option>
              </b-form-select>
              <div v-if="parentTopicEmpty" style="color: red">
                Parent topic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="parentTopic != ''">
              Topic
              <b-form-select v-model="topic" @change="getSubtopics()" required>
                <option
                  v-for="(topic, index) in topics"
                  :key="index"
                  :value="topic.id"
                >
                  {{ topic.name }}
                </option>
              </b-form-select>
              <div v-if="topicEmpty" style="color: red">Topic is required</div>
            </div>

            <div class="col-md-6 form-group" v-if="topic != ''">
              Sub Topic
              <b-form-select
                v-model="subtopic"
                @change="getQuestions()"
                required
              >
                <option
                  v-for="(subtopic, index) in subtopics"
                  :key="index"
                  :value="subtopic.id"
                >
                  {{ subtopic.name }}
                </option>
              </b-form-select>
              <div v-if="subtopicEmpty" style="color: red">
                Subtopic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="subtopic != ''">
              Free Status
              <b-form-select
                v-model="freeStatus"
                @change="freeStatusEmpty = false"
                required
              >
                <option value="0">Paid</option>
                <option value="1">Free</option>
              </b-form-select>
              <div v-if="freeStatusEmpty" style="color: red">
                Free status is required
              </div>
            </div>

            <div class="col-md-12" v-if="questionData != ''">
              <dl class="float-right">
                <dt class="green"></dt>
                <dd>Fillups</dd>

                <dt class="blue"></dt>
                <dd>Group</dd>

                <dt class="grey"></dt>
                <dd>MCQ</dd>
                <dt class="yellow"></dt>
                <dd>Coding</dd>
              </dl>
            </div>

            <div class="col-md-12">
              <h3 class="block-title" v-if="questionData != ''">
                Select Questions for test
              </h3>

              <b-list-group
                class="list-group"
                v-for="(question, index) in questionData"
                :key="index"
              >
                <b-list-group-item
                  :class="
                    questionData[index].question_type == 'fill_in_blank'
                      ? 'border-warning mb-1'
                      : questionData[index].question_type == 'group'
                      ? 'border-primary mb-1'
                      : questionData[index].question_type == 'coding'
                      ? 'border-success mb-1'
                      : 'border-dark mb-1'
                  "
                >
                  <b-button
                    size="sm"
                    class="float-right"
                    v-on:click="addQuestions(question)"
                    :variant="
                      questionData[index].question_type == 'group'
                        ? selectedQuestion.includes(question)
                          ? 'danger'
                          : 'success'
                        : selectedQuestion.includes(question)
                        ? 'danger'
                        : 'success'
                    "
                    ><i
                      :class="
                        questionData[index].question_type == 'group'
                          ? selectedQuestion.includes(question)
                            ? 'fa fa-fw fa-times'
                            : 'fa fa-fw fa-check'
                          : selectedQuestion.includes(question)
                          ? 'fa fa-fw fa-times'
                          : 'fa fa-fw fa-check'
                      "
                    ></i
                  ></b-button>
                  <p v-html="questionData[index].question"></p>
                </b-list-group-item>
              </b-list-group>

              <div v-if="selectedQuestion != ''">
                <b-button
                  variant="success"
                  class="float-right ml-2 mt-4"
                  @click="insert()"
                  >Insert</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right mt-4"
                  @click="cancel()"
                  >Cancel</b-button
                >
                <div class="form-group mt-2">
                  No.Of Questions Selected
                  <input
                    type="text"
                    class="form-control col-md-3"
                    v-model="totalQuestionCount"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <div
          class="mt-2 col-md-12"
          v-if="testType == 'default' && testType != ''"
        >
          <b-button
            class="float-right mb-4"
            variant="success"
            v-b-modal.modal-1
            @click="getParentTopics()"
            v-if="finalArray.length < 1"
            >Add Questions</b-button
          >
        </div>

        <div
          class="mt-2 col-md-12"
          v-if="testType == 'random' && testType != ''"
        >
          <b-button
            class="float-right mb-4"
            variant="success"
            v-b-modal.modal-3
            @click="getParentTopics()"
            v-if="finalArray2.length < 1"
            >Add Questions</b-button
          >
        </div>

        <div class="col-md-12" v-if="finalArray != '' && testType == 'default'">
          Test Contents
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Topic</b-th>
                <b-th class="text-center">Subtopic</b-th>
                <b-th class="text-center">Total Question Count</b-th>
                <b-th class="text-center">Free Status</b-th>
                <b-th class="text-center">Selected Questions</b-th>
                <b-th class="text-center">Actions</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(final, index) in finalArray" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ final.parentTopic.name }} </b-td>
                <b-td class="text-center"> {{ final.topic.name }} </b-td>
                <b-td class="text-center"> {{ final.subtopic.name }} </b-td>
                <b-td class="text-center">
                  {{ final.totalQuestionCount }}
                </b-td>
                <b-td class="text-center">
                  {{ final.freeStatus == 0 ? "Paid" : "Free" }}
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    v-b-modal.modal-2
                    @click="modal2Data = final.selectedQuestionArray"
                  >
                    <i class="fa fa-fw fa-eye"></i>
                  </b-button>
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="removeRow(index)"
                  >
                    <i class="fa fa-fw fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <!-- Random Table -->
        <div class="col-md-12" v-if="finalArray2 != '' && testType == 'random'">
          Test Contents
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Topic</b-th>
                <b-th class="text-center">Subtopic</b-th>
                <b-th class="text-center">Total Question Count</b-th>
                <b-th class="text-center">Free Status</b-th>
                <b-th class="text-center">Actions</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(final, index) in finalArray2" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ final.parentTopic.name }} </b-td>
                <b-td class="text-center"> {{ final.topic.name }} </b-td>
                <b-td class="text-center"> {{ final.subtopic.name }} </b-td>
                <b-td class="text-center">
                  {{ final.totalQuestionCount }}
                </b-td>
                <b-td class="text-center">
                  {{ final.freeStatus == 0 ? "Paid" : "Free" }}
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="removeRowRandom(index)"
                  >
                    <i class="fa fa-fw fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <!-- modal2 -->

        <b-modal
          id="modal-2"
          ref="modaltwo"
          title="Selected Questions"
          ok-variant="success"
          no-close-on-esc
          no-close-on-backdrop
          cancel-variant="danger"
          size="xl"
          @ok="modal2Data = []"
          @cancel="modal2Data = []"
          @close="modal2Data = []"
        >
          <div class="row">
            <div class="col-md-12">
              <dl class="float-right">
                <dt class="green"></dt>
                <dd>Fillups</dd>

                <dt class="blue"></dt>
                <dd>Group</dd>

                <dt class="grey"></dt>
                <dd>MCQ</dd>
                <dt class="yellow"></dt>
                <dd>Coding</dd>
              </dl>
            </div>

            <div class="col-md-12 form-group">
              <b-list-group v-for="(data, index) in modal2Data" :key="index">
                {{ mathRender() }}
                <b-list-group-item
                  v-html="`${data.question}`"
                  :class="
                    data.question_type == 'fill_in_blank'
                      ? 'border-warning mb-1'
                      : data.question_type == 'group'
                      ? 'border-primary mb-1'
                      : data.question_type == 'coding'
                      ? 'border-success mb-1'
                      : 'border-dark mb-1'
                  "
                ></b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </b-modal>

        <!-- modal-3 -->
        <b-modal
          id="modal-3"
          title="Add Questions"
          size="xl"
          ref="modalthree"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="
            (parentTopic = ''),
              (topic = ''),
              (subtopic = ''),
              (freeStatus = ''),
              (freeStatusEmpty = false),
              (info = ''),
              (questionCount = ''),
              (parentTopicEmpty = false),
              (topicEmpty = false),
              (subtopicEmpty = false),
              (infoAlert = false),
              (questionCountEmpty = false)
          "
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Parent Topic
              <b-form-select
                v-model="parentTopic"
                @change="getTopics()"
                required
              >
                <option
                  v-for="(parentTopic, index) in parentTopics"
                  :key="index"
                  :value="parentTopic.id"
                >
                  {{ parentTopic.name }}
                </option>
              </b-form-select>
              <div v-if="parentTopicEmpty" style="color: red">
                Parent topic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="parentTopic != ''">
              Topic
              <b-form-select v-model="topic" @change="getSubtopics()" required>
                <option
                  v-for="(topic, index) in topics"
                  :key="index"
                  :value="topic.id"
                >
                  {{ topic.name }}
                </option>
              </b-form-select>
              <div v-if="topicEmpty" style="color: red">Topic is required</div>
            </div>

            <div class="col-md-6 form-group" v-if="topic != ''">
              Sub Topic
              <b-form-select v-model="subtopic" @change="getInfo()" required>
                <option
                  v-for="(subtopic, index) in subtopics"
                  :key="index"
                  :value="subtopic.id"
                >
                  {{ subtopic.name }}
                </option>
              </b-form-select>
              <div v-if="subtopicEmpty" style="color: red">
                Subtopic is required
              </div>
            </div>

            <div v-if="subtopic != ''" class="col-md-6 form-group">
              Question Availability Info
              <div
                class="alert alert-info mb-0"
                role="alert"
                style="padding: 6px 12px"
              >
                {{ info }}
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="subtopic != ''">
              Question Count
              <input
                type="number"
                @input="enableAlert()"
                v-model="questionCount"
                class="form-control"
                @focus="(questionCountEmpty = false), (infoAlert = false)"
              />
              <div v-if="questionCountEmpty" style="color: red">
                Question count is required
              </div>
              <div v-if="infoAlert" style="color: red">
                Question count should not be greater than
                {{
                  Number(this.info.split(" ")[1]) +
                    Number(this.info.split(" ")[3])
                }}
              </div>
            </div>
            <div class="col-md-6 form-group" v-if="questionCount != ''">
              Free Status
              <b-form-select
                v-model="freeStatus"
                @change="freeStatusEmpty = false"
                required
              >
                <option value="1">Free</option>
                <option value="0">Paid</option>
              </b-form-select>
              <div v-if="freeStatusEmpty" style="color: red">
                Free status is required
              </div>
            </div>
          </div>
          <b-button
            v-if="questionCount != ''"
            variant="success"
            class="float-right ml-2"
            @click="insertRandom()"
            >Insert</b-button
          >
          <b-button
            v-if="questionCount != ''"
            variant="danger"
            class="float-right"
            @click="cancelRandom()"
            >Cancel</b-button
          >
        </b-modal>

        <div
          class="text-center form-group"
          style="width: 100%"
          v-if="finalArray != '' && testType == 'default'"
        >
          <b-button variant="success" @click="save()">Save</b-button>
        </div>

        <div
          class="text-center form-group"
          style="width: 100%"
          v-if="finalArray2 != '' && testType == 'random'"
        >
          <b-button variant="success" @click="saveRandom()">Save</b-button>
        </div>
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    mathRender() {
      if ("MathJax" in window) {
        this.$nextTick(async function() {
          await window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
    async saveRandom() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.attempts == "") {
        this.attemptsEmpty = true;
        return;
      }
      if (this.negativeMarks == "") {
        this.negativeMarkEmpty = true;
        return;
      }
      if (this.eachQuestionMark == "") {
        this.eachQuestionMarkEmpty = true;
        return;
      }
      if (this.resultStatus == "") {
        this.resultStatusEmpty = true;
        return;
      }
      if (this.duration == "") {
        this.durationEmpty = true;
        return;
      }
      if (this.testType == "") {
        this.testTypeEmpty = true;
        return;
      }
      this.loader = true;
      const formdata = new FormData();
      formdata.append("topic_id", this.finalArray2[0].parentTopic.id);
      formdata.append("sub_topic_id", this.finalArray2[0].topic.id);
      formdata.append("child_topic_id", this.finalArray2[0].subtopic.id);
      formdata.append("has_coding", this.has_coding);
      formdata.append("play_button", this.play_button);
      formdata.append("test[description]", this.description);
      formdata.append("test[test_type]", this.testType);
      formdata.append("test[duration]", this.duration);
      formdata.append("status", this.finalArray2[0].freeStatus);
      formdata.append(
        "test[no_of_questions]",
        this.finalArray2[0].totalQuestionCount
      );
      formdata.append("test[attempts]", this.attempts);
      formdata.append("test[negative_mark]", this.negativeMarks);
      formdata.append("test[each_question_mark]", this.eachQuestionMark);
      formdata.append("test[result_status]", this.resultStatus);
      formdata.append("test[name]", this.name);

      await axios
        .post(
          `${this.$store.getters.baseUrl}/sub_practice_store/${this.$route.params.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Practice test saved successfully",
              "success"
            );
            this.$router.push({ name: "Subscription Practice Test" });
            (this.name = ""),
              (this.description = ""),
              (this.attempts = ""),
              (this.negativeMarks = ""),
              (this.eachQuestionMark = ""),
              (this.resultStatus = ""),
              (this.duration = ""),
              (this.testType = ""),
              (this.finalArray2 = []);
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    removeRowRandom(index) {
      this.finalArray2.splice(index, 1);
    },
    cancelRandom() {
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.freeStatus = ""),
        (this.parentTopics = []),
        (this.topics = []),
        (this.subtopics = []);
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.questionCountEmpty = false),
        (this.infoAlert = false),
        this.$refs.modalthree.hide();
    },

    enableAlert() {
      if (
        Number(this.questionCount) >
        Number(this.info.split(" ")[1]) + Number(this.info.split(" ")[3])
      ) {
        this.infoAlert = true;
      }
    },

    insertRandom() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }
      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }
      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
      if (this.questionCount == "") {
        this.questionCountEmpty = true;
        return;
      }
      if (this.freeStatus == "") {
        this.freeStatusEmpty = true;
        return;
      }

      var selectedParentTopic = "";
      for (var i = 0; i < this.parentTopics.length; i++) {
        if (this.parentTopics[i].id == this.parentTopic) {
          selectedParentTopic = this.parentTopics[i];
        }
      }
      var selectedTopic = "";
      for (var j = 0; j < this.topics.length; j++) {
        if (this.topics[j].id == this.topic) {
          selectedTopic = this.topics[j];
        }
      }
      var selectedSubtopic = "";
      for (var k = 0; k < this.subtopics.length; k++) {
        if (this.subtopics[k].id == this.subtopic) {
          selectedSubtopic = this.subtopics[k];
        }
      }

      this.finalArray2.push({
        parentTopic: selectedParentTopic,
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        totalQuestionCount: this.questionCount,
        freeStatus: this.freeStatus,
      });
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.freeStatus = ""),
        (this.questionCount = ""),
        (this.parentTopics = []),
        (this.topics = []),
        (this.subtopics = []);
      this.$refs.modalthree.hide();
    },

    removeRow(index) {
      this.finalArray.splice(index, 1);
    },
    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.attempts == "") {
        this.attemptsEmpty = true;
        return;
      }
      if (this.negativeMarks == "") {
        this.negativeMarkEmpty = true;
        return;
      }
      if (this.eachQuestionMark == "") {
        this.eachQuestionMarkEmpty = true;
        return;
      }
      if (this.resultStatus == "") {
        this.resultStatusEmpty = true;
        return;
      }
      if (this.duration == "") {
        this.durationEmpty = true;
        return;
      }
      if (this.testType == "") {
        this.testTypeEmpty = true;
        return;
      }
      let finalArr = [];
      for (
        var i = 0;
        i < this.finalArray[0].selectedQuestionArray.length;
        i++
      ) {
        if (
          this.finalArray[0].selectedQuestionArray[i].question_type == "group"
        ) {
          for (
            var j = 0;
            j < this.finalArray[0].selectedQuestionArray[i].subquestions.length;
            j++
          ) {
            finalArr.push(
              this.finalArray[0].selectedQuestionArray[i].subquestions[j].id
            );
          }
        } else {
          finalArr.push(this.finalArray[0].selectedQuestionArray[i].id);
        }
      }
      this.loader = true;
      const formdata = new FormData();
      formdata.append("topic_id", this.finalArray[0].parentTopic.id);
      formdata.append("sub_topic_id", this.finalArray[0].topic.id);
      formdata.append("child_topic_id", this.finalArray[0].subtopic.id);
      for (var k = 0; k < finalArr.length; k++) {
        formdata.append("questions[" + k + "]", finalArr[k]);
      }
      formdata.append("test[description]", this.description);
      formdata.append("test[test_type]", this.testType);
      formdata.append("test[duration]", this.duration);
      formdata.append("status", this.finalArray[0].freeStatus);
      formdata.append(
        "test[no_of_questions]",
        this.finalArray[0].totalQuestionCount
      );
      formdata.append("test[attempts]", this.attempts);
      formdata.append("test[negative_mark]", this.negativeMarks);
      formdata.append("test[each_question_mark]", this.eachQuestionMark);
      formdata.append("test[result_status]", this.resultStatus);
      formdata.append("test[name]", this.name);
      formdata.append("has_coding", this.has_coding);
      formdata.append("play_button", this.play_button);

      await axios
        .post(
          `${this.$store.getters.baseUrl}/sub_practice_store/${this.$route.params.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Practice test saved successfully",
              "success"
            );
            this.$router.push({ name: "Subscription Practice Test" });
            (this.name = ""),
              (this.description = ""),
              (this.attempts = ""),
              (this.negativeMarks = ""),
              (this.eachQuestionMark = ""),
              (this.resultStatus = ""),
              (this.duration = ""),
              (this.testType = "");
            this.finalArray = [];
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    cancel() {
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.freeStatus = ""),
        (this.totalQuestionCount = 0),
        (this.selectedQuestion = []),
        (this.questionData = []),
        (this.parentTopics = []),
        (this.topics = []),
        (this.subtopics = []);
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false);
      this.$refs.modalone.hide();
    },
    insert() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }
      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }
      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
      if (this.freeStatus == "") {
        this.freeStatusEmpty = true;
        return;
      }
      var selectedParentTopic = "";
      for (var i = 0; i < this.parentTopics.length; i++) {
        if (this.parentTopics[i].id == this.parentTopic) {
          selectedParentTopic = this.parentTopics[i];
        }
      }
      var selectedTopic = "";
      for (var j = 0; j < this.topics.length; j++) {
        if (this.topics[j].id == this.topic) {
          selectedTopic = this.topics[j];
        }
      }
      var selectedSubtopic = "";
      for (var k = 0; k < this.subtopics.length; k++) {
        if (this.subtopics[k].id == this.subtopic) {
          selectedSubtopic = this.subtopics[k];
        }
      }

      this.finalArray.push({
        parentTopic: selectedParentTopic,
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        selectedQuestionArray: this.selectedQuestion,
        totalQuestionCount: this.totalQuestionCount,
        freeStatus: this.freeStatus,
      });
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.freeStatus = ""),
        (this.totalQuestionCount = 0),
        (this.selectedQuestion = []),
        (this.questionData = []),
        (this.parentTopics = []),
        (this.topics = []),
        (this.subtopics = []);
      this.$refs.modalone.hide();
    },
    addQuestions(question) {
      if (this.selectedQuestion.includes(question)) {
        let index = this.selectedQuestion.indexOf(question);
        this.selectedQuestion.splice(index, 1);
        if (question.question_type == "group") {
          this.totalQuestionCount =
            this.totalQuestionCount - question.subquestions.length;
        } else {
          this.totalQuestionCount = this.totalQuestionCount - 1;
        }
      } else {
        this.selectedQuestion.push(question);
        if (question.question_type == "group") {
          this.totalQuestionCount =
            this.totalQuestionCount + question.subquestions.length;
        } else {
          this.totalQuestionCount = this.totalQuestionCount + 1;
        }
      }
      console.log(this.selectedQuestion);
    },

    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.subtopic = "";
      this.topic = "";
      this.freeStatus = "";
      this.selectedQuestion = [];
      this.totalQuestionCount = 0;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub_practicetest_topics/${this.$route.params.id}/${this.parentTopic}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      this.freeStatus = "";
      this.selectedQuestion = [];
      this.totalQuestionCount = 0;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub_practicetest_topics/${this.$route.params.id}/${this.parentTopic}/${this.topic}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subtopics = response.data.childtopics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getInfo() {
      this.subtopicEmpty = false;
      if (this.testType == "random") {
        console.log(this.subtopic);
        await axios
          .get(
            `${this.$store.getters.baseUrl}/recruitment-drives/question-count/${this.subtopic}`,
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.token}`,
              },
            }
          )
          .then((response) => {
            console.log(response);
            if (response.data.status == "success") {
              this.info = `Fillups: ${response.data.number_of_fill_in_blank} MCQ: ${response.data.number_of_objective} Group Question: ${response.data.number_of_group} Coding: ${response.data.number_of_coding}`;
            }
          });
      }
    },

    async getQuestions() {
      this.subtopicEmpty = false;
      this.selectedQuestion = [];
      this.totalQuestionCount = 0;
      await axios
        .get(`${this.$store.getters.baseUrl}/questionlist/${this.subtopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questionData = response.data.questions;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      if ("MathJax" in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
  data() {
    return {
      loader: false,
      freeStatus: "",
      freeStatusEmpty: false,
      name: "",
      nameEmpty: false,
      infoAlert: false,
      durationEmpty: false,
      finalArray2: [],
      questionCountEmpty: false,
      questionCount: "",
      attempts: "",
      attemptsEmpty: false,
      totalQuestionCount: 0,
      modal2Data: [],
      finalArray: [],
      selectedQuestion: [],
      duration: "",
      testTypeEmpty: false,
      resultStatusEmpty: false,
      eachQuestionMarkEmpty: false,
      negativeMarkEmpty: false,
      descriptionEmpty: false,
      info: "",
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      eachQuestionMark: "",
      negativeMarks: "",
      description: "",
      testType: "",
      resultStatus: "",
      resultStatusOptions: [
        { text: "No Result", value: 3 },
        { text: "Result", value: 1 },
        { text: "Result & Solution", value: 2 },
      ],
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
      questionData: [],
      has_coding: 0,
      play_button: 0,
    };
  },
};
</script>
<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
dl dt.yellow {
  background: #30c78d;
}
</style>
